import {http} from '../../plugins/http';

export default {

    index(params) {
        return http.get('/api/v1/projects/tasks/search', {
            params: params
        });
    },

    search(params) {
        return http.post('/api/v1/projects/tasks/search', params);
    },

    searchForLinks(params) {
        return http.post('/api/v1/projects/tasks/search/for-links', params);
    },

    exportToExcel(params) {
        return http.post('/api/v1/projects/tasks/search/export', params);
    },

    getStatusCountsForUser(userKey, params) {
        return http.get(`/api/v1/projects/tasks/search/status-counts/${userKey}`, {
            params: params
        });
    },

    getUserBookmarkedTasks(userKey, params) {
        return http.get(`/api/v1/projects/tasks/search/user-bookmarks/${userKey}`, {
            params: params
        });
    },

    taskIsAccessibleByUser(params) {
        return http.get(`/api/v1/projects/tasks/search/task-is-accessible-by-user`, {
            params: params
        });
    }

};



// WEBPACK FOOTER //
// ./src/services/Tasks/TaskSearchController.js